// src/portals/fan/pages/SettingsPage/components/SettingsToggle.js
import React, { useState } from "react";
import { Switch } from "@headlessui/react";

const SettingsToggle = ({ label, description, initialValue = true }) => {
  const [enabled, setEnabled] = useState(initialValue);

  return (
    <div className="flex items-center justify-between p-4">
      <div className="flex-grow pr-4">
        <h3 className="font-medium text-slate-800">{label}</h3>
        <p className="text-sm text-slate-500">{description}</p>
      </div>
      <Switch
        checked={enabled}
        onChange={setEnabled}
        className={`${
          enabled ? "bg-primary" : "bg-slate-300"
        } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
      >
        <span
          className={`${
            enabled ? "translate-x-6" : "translate-x-1"
          } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
        />
      </Switch>
    </div>
  );
};

export default SettingsToggle;
